(function() {
  'use strict';
  
  // Check if already initialized
  if (window.videoAutoplayInitialized) {
    return;
  }
  window.videoAutoplayInitialized = true;

  // observer for the video to be in viewport
  function handleIntersection(entries) {
    entries.forEach(entry => {
      const video = entry.target;
      if (entry.isIntersecting) {
        const posterButton = video.querySelector('button.video-section__poster');
        if (posterButton) {
          posterButton.click();
        }
        observer.unobserve(video);
      }
    });
  }

  const observer = new IntersectionObserver(handleIntersection, {
    threshold: 0.25
  });

  const videos = document.querySelectorAll('.video-section.home-video');

  videos.forEach(video => {
    observer.observe(video);
  });

  // mute and unmute the video
  const audioButtons = document.querySelectorAll('button.audio-btn');

  audioButtons.forEach(audioButton => {
    audioButton.addEventListener('click', () => {
      const audio = audioButton.nextElementSibling;
      if (audio) {
        audio.muted = !audio.muted;
        audioButton.classList.toggle('audio-btn--playing');
      }
    });
  });
})();